/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import Select from 'react-select';
import { getParcelsInPrecint } from '../../lib/utils';
import MessageModal from './MessageModal';
import ModalAlert from './ModalAlert';
import waiting from './images/waiting-wheel-300x300.gif';
import { connect } from 'react-redux';

const isBrowser = typeof window !== 'undefined' && window !== null;
let Map, TileLayer, L, WMSTileLayer, Rectangle, GeoJSON, Pan, MyPan, Marker;

if (isBrowser) {
  Map = require('react-leaflet/lib/Map').default;
  TileLayer = require('react-leaflet/lib/TileLayer').default;
  WMSTileLayer = require('react-leaflet/lib/WMSTileLayer').default;
  Rectangle = require('react-leaflet/lib/Rectangle').default;
  GeoJSON = require('react-leaflet/lib/GeoJSON').default;
  Marker = require('react-leaflet/lib/Marker').default;
  L = require('leaflet');
}
// Styling of waitingCircle
const waitingContainer = {
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '30px',
  marginBottom: '30px',
  display: 'block',
  maxWidth: '600px',
  width: '100%',
  textAlign: 'center',
};

const geomStyle = {
  color: '#FF7800',
  weight: 1,
  opacity: 1,
  fillOpacity: 0,
  zIndex: 1,
};

const selectedGeomStyle = {
  color: '#008FFF',
  weight: 5,
  opacity: 1,
  zIndex: 2,
};

const drawingGeomStyle = {
  color: '#08FF00',
  weight: 5,
  opacity: 1,
  zIndex: 2,
};

const highlightedGeomStyle = {
  color: '#FF0000',
  weight: 6,
  opacity: 1,
  zIndex: 3,
};

const treeBtnStyle = { position: 'relative', top: '176px', height: '32px', width: '32px', zIndex: 1000, boxSizing: 'border-box', left: '12px', lineHeight: '30px', borderRadius: '4px', backgroundImage: "url('https://cdn1.iconfinder.com/data/icons/ui-set-4-1/512/tree_park_garden-128.png')", backgroundColor: '#fff', backgroundRepeat: 'no-repeat', backgroundSize: '75% 75%', backgroundPosition: '50% 50%', border: '2px solid rgba(0,0,0,0.2)' };
const treeBtnSelectedStyle = { position: 'relative', top: '176px', height: '32px', width: '32px', zIndex: 1000, boxSizing: 'border-box', left: '12px', lineHeight: '30px', borderRadius: '4px', backgroundImage: "url('https://cdn1.iconfinder.com/data/icons/ui-set-4-1/512/tree_park_garden-128.png')", backgroundColor: '#9898d2', backgroundRepeat: 'no-repeat', backgroundSize: '75% 75%', backgroundPosition: '50% 50%', border: '2px solid rgba(50, 29, 113, 0.7)' };
const numberIconStyle = {
  width: '24px',
  height: '24px',
  marginLeft: '-12px',
  marginTop: '-12px',
  borderRadius: '18px',
  border: '2px solid black',
  textAlign: 'center',
  color: 'black',
  backgroundColor: 'red',
  fontSize: '16px',
};

const CalculateCenter = bounds => {
  return [(bounds.maxy + bounds.miny) / 2, (bounds.maxx + bounds.minx) / 2];
}

const getCenterAsObj = bounds => {
  return { lat: (bounds.maxy + bounds.miny) / 2, lng: (bounds.maxx + bounds.minx) / 2 };
}

const zoom = 8;

class CustomizedMap extends React.Component {
  constructor(props) {
    super(props);

    this.start_bounds = {
      maxx: this.props.mapState.maxLat,
      maxy: this.props.mapState.maxLon,
      minx: this.props.mapState.minLat,
      miny: this.props.mapState.minLon,
    }
    this.map_center = [this.props.mapState.centerLon, this.props.mapState.centerLat];

    this.state = {
      bounds: this.start_bounds,
      center: this.map_center,
      prefix: this.props.prefix,
      selectedPrecint: '',
      isMounted: false,
      parcelFeatures: [],
      listTrees: [],
      drawingPoints: 0,
      polyDrawingFeature: {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [],
        },
      },
      polyDrawingMarkers: [],
      drogiFeatures: {
        type: 'FeatureCollection',
        features: [],
      },
      isSelectionEnabled: false,
      isRectangleDrawingEnabled: false,
      isPolygonDrawingEnabled: false,
      isTreeSelectionEnabled: false,
      selectedParcels: [],
      parcels: null,
      roadFeatures: [],
      selectedRoads: [], // Wybrane drogi
      roads: null, //Wszystkie drogi
      selectedAddress: '',
      adresses: null,
      startPoint: null,
      endPoint: null,
      showMessage: false,
      areParcelsInMPZP: true,
      nonMpzpAlert: false,
      nonMpzpList: [],
      selectWybor: false, //czy pokazac input z wyborem
      selectDzialki: false, //Czy pokazac wybor z dzialkami
      selectDrogi: false, //Czy pokazac wybor z drogami
      selectedSposob: '0', //Wybrany sposob drogi/dzialki
      errorTitle: null,
      errorText: null,
      showError: false,
      parcelError: null,
    };
  }

  hideTime = 2000;

  onHideErrorModal = () => this.setState({ showError: false });

  componentDidMount = () => {
    // this.setState({ selectedPrecint: this.props.obreby[0].obreb, isMounted: true }, () => this.getParcelsForPrecint());

    // Wczytuje drogi podczas ladownaia strony
    // Wylaczone drogi dla Skierniewic
    // if (this.props.dokumentType.enableRoads && this.state.prefix != 'skierniewice') {
    //   const url = `${process.env.API_URL}/eservices/${this.state.prefix}/roads`;
    //   fetch(url, { method: 'GET' })
    //     .then(r => {
    //       return r.json();
    //     })
    //     .then(resp => {

    //       //Zapisuje do state i usuwa drogi, ktore nie maja nazwy
    //       this.setState({
    //         roads: resp.droga.map(v => {
    //           return { label: v.nr, value: v.nr, id: v.id }
    //         }).filter(function (v) {
    //           if (v.label !== null) return v;
    //         })
    //       })
    //     });

    //   this.setState({
    //     selectWybor: true,
    //     selectedSposob: 2,
    //     selectDrogi: true
    //   });
    // } else {
    //   this.setState({
    //     selectWybor: false,
    //     selectedSposob: 1,
    //     selectDzialki: true,
    //   });
    // }

    this.setState({
      isMounted: true,
      selectWybor: false,
      selectedSposob: 1,
      selectDzialki: true,
    });
  };

  // componentDidUpdate() {
  //   console.log('DID update', this.props.selectedGeoms);
  //   // this.mapRender();
  // }

  onChangePrecint = (e) => this.setState({ selectedPrecint: e.target.value }, () => this.getParcelsForPrecint());

  setParcelError = err => this.setState({
    parcelError: err,
  }, () => setTimeout(() => {
    this.setState({ parcelError: null })
  }, this.hideTime));

  bindButtons = () => {
    if (this.mapka) {
      this.mapka.leafletElement.doubleClickZoom.disable();
      this.mapka.leafletElement.on({
        click: this.whenClicked,
      });
      this.mapka.leafletElement.on("zoomend", (e) => this.onZoomEnd(e));
    }
  }

  onZoomEnd = (e) => {
    if (e.target._zoom === zoom) {
      this.mapka.leafletElement.fitBounds([
        [this.start_bounds.miny, this.start_bounds.minx],
        [this.start_bounds.maxy, this.start_bounds.maxx],
      ]);
    }
  }

  unBindButtons = () => {
    if (this.mapka) {
      this.mapka.leafletElement.doubleClickZoom.enable();
      this.mapka.leafletElement.off({
        click: this.whenClicked,
      });
    }
  }

  removeLastPoint = () => {
    if (this.props.selectedMaterialName) {
      let drawingPoints = this.state.drawingPoints;
      if (drawingPoints === 1) {
        this.cancelDrawing();
      } else {
        const polyDrawingFeature = this.state.polyDrawingFeature;
        const coords = polyDrawingFeature.geometry.coordinates;
        if (drawingPoints === 2) {
          polyDrawingFeature.geometry.type = 'Point';
          polyDrawingFeature.geometry.coordinates = coords[0];
        } else if (drawingPoints === 3) {
          polyDrawingFeature.geometry.type = 'LineString';
          polyDrawingFeature.geometry.coordinates = [coords[0][0], coords[0][1]];
        } else if (drawingPoints > 3) {
          polyDrawingFeature.geometry.type = 'Polygon';
          polyDrawingFeature.geometry.coordinates[0].splice(-1, 1);
        }

        if (drawingPoints > 0) {
          drawingPoints -= 1;
        }
        this.setState({ drawingPoints, polyDrawingFeature }, () => this.updatePolyDrawingMarkers());
      }
    }
  }

  cancelDrawing = () => {
    if (this.props.selectedMaterialName) {
      const polyDrawingFeature = this.state.polyDrawingFeature;
      polyDrawingFeature.geometry.type = 'Point';
      polyDrawingFeature.geometry.coordinates = [];

      let drawingPoints = this.state.drawingPoints;
      drawingPoints = 0;

      this.setState({ drawingPoints, polyDrawingFeature }, () => this.bindAndUpdate());
    }
  }

  bindAndUpdate = () => {
    this.updatePolyDrawingMarkers();
    this.bindButtons();
  }

  finishPolyDrawing = () => {
    if (this.props.selectedMaterialName) {
      const coords = this.state.polyDrawingFeature.geometry.coordinates;
      this.props.addGeomByDrawedPolyIntersection(this.props.idx, coords, this.state.drawingPoints);
      this.cancelDrawing();
    }
  };

  updatePolyDrawingMarkers = () => {
    const polyDrawingMarkers = [];
    const drawingGeom = this.state.polyDrawingFeature.geometry;
    const drawingPoints = this.state.drawingPoints;

    if (drawingPoints > 0) {
      // Point
      if (drawingPoints === 1) {
        const latlng = {
          lat: drawingGeom.coordinates[1],
          lng: drawingGeom.coordinates[0],
        };
        polyDrawingMarkers.push(latlng);
        // LineString
      } else if (drawingPoints === 2) {
        for (const coords of drawingGeom.coordinates) {
          const latlng = {
            lat: coords[1],
            lng: coords[0],
          };
          polyDrawingMarkers.push(latlng);
          // Polygon
        }
      } else {
        for (const coords of drawingGeom.coordinates[0]) {
          const latlng = {
            lat: coords[1],
            lng: coords[0],
          };
          polyDrawingMarkers.push(latlng);
        }
      }
    }

    this.setState({ polyDrawingMarkers });
  }

  addTree = (e) => {
    this.setState({
      listTrees: [...this.state.listTrees, {
        number: this.getTreeNumber(),
        latlng: e.latlng,
      }],
    });
  }

  getTreeNumber = () => {
    let number = 0;
    for (const tree of this.state.listTrees) {
      if (tree.number > number) {
        number = tree.number;
      }
    }
    return (number + 1);
  }

  getParcelInPointURL = (latlng) => {
    let baseURL = `${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel_in_point?lat=${latlng.lat}&lng=${latlng.lng}`;
    if (this.props.serviceType === 'ZimoweUtrzymanieDrog') {
      return `${baseURL}${'&check_intersection=' + 'zimowe_utrzymanie_drog'}`;
    }

    if (this.props.serviceType === 'PrzebiegDrogiInfo') {
      return `${baseURL}${'&check_intersection=' + 'zimowe_utrzymanie_drog'}`;
    }
    return baseURL;
  }

  getParcelInPoint = latlng => fetch(this.getParcelInPointURL(latlng),
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw r;
    })
    .catch(err => {
      this.setState({
        showMessage: true,
      });
    })

  getRoadInPoint = latlng => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/road_in_point?lat=${latlng.lat}&lng=${latlng.lng}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw "Road not found"
    })

  onMouseDown = (e) => {
    // if (this.state.isSelectionEnabled) {
    //   const d = new Date();
    //   this.setState({ startPoint: e.latlng, ctrState: e.originalEvent.ctrlKey, startSelectTime: d.getTime() });
    // }
    if (this.state.isRectangleDrawingEnabled) {
      const d = new Date();
      this.setState({ startPoint: e.latlng, ctrState: e.originalEvent.ctrlKey, startSelectTime: d.getTime() });
    }
  };

  // onKeyDown = (e) => {
  //   // if (this.state.isSelectionEnabled) {
  //   //   const d = new Date();
  //   //   this.setState({ startPoint: e.latlng, ctrState: e.originalEvent.ctrlKey, startSelectTime: d.getTime() });
  //   // }
  //   if (this.state.isRectangleDrawingEnabled) {
  //     console.log("onKeyDown");
  //     console.log(e);
  //   }
  // };

  // onkeypress = (e) => {
  //   // if (this.state.isSelectionEnabled) {
  //   //   const d = new Date();
  //   //   this.setState({ startPoint: e.latlng, ctrState: e.originalEvent.ctrlKey, startSelectTime: d.getTime() });
  //   // }
  //   if (this.state.isRectangleDrawingEnabled) {
  //     console.log("onkeypress");
  //   }
  // };

  getParcelsForPrecint = () => getParcelsInPrecint(this.props.district.teryt, this.state.selectedPrecint)
    .then(resp => this.setState({
      parcels: resp.dzialki.map(v => {
        return { value: v, label: v, obreb: this.state.selectedPrecint };
      }),
    })).then(() => this.setState({ parc: this.state.parcels }));

  clearSelection = () => {
    this.props.setParcels([]);
    this.setState({
      parcelFeatures: [], selectedParcels: [], selectedRoads: [], drogiFeatures: {
        ...this.state.drogiFeatures,
        features: []
      }
    }, () => {
      if (this.drogi) {
        this.drogi.leafletElement.clearLayers();
      }
      if (this.dzialki) {
        this.dzialki.leafletElement.clearLayers();
      }
      this.props.setRoads([]);
      this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds), 11);
    });
  }

  logChange = val => {
    let parcel = null;
    let isAdding = null;
    if (this.state.selectedParcels.length > val.length) {
      parcel = _.differenceWith(this.state.selectedParcels, val, _.isEqual)[0];
      isAdding = false;
    }
    if (this.state.selectedParcels.length < val.length) {
      parcel = _.differenceWith(val, this.state.selectedParcels, _.isEqual)[0];
      isAdding = true;
    }
    if (parcel) {
      this.setState({ selectedParcels: val, isMouseEvent: false }, isAdding ? () => this.addParcelToMap(parcel) : () => this.removeParcelFromMap(parcel));
    }
  }

  // Fetches road by its id
  getRoadByID = id => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/road/${id}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw "Nie znaleziono drogi";
    })


  roadAdd = road => this.getRoadByID(road.id)
    .then(resp => {
      this.setState({
        selectedRoads: this.state.selectedRoads.concat(road), isMouseEvent: false, drogiFeatures: {
          ...this.state.drogiFeatures,
          features: this.state.drogiFeatures.features.concat(resp),
        }
      }, this.refreshRoads);
    });

  roadRemove = road => {
    this.setState({
      selectedRoads: _.filter(this.state.selectedRoads, v => v.id !== road.id),
      drogiFeatures: {
        ...this.state.drogiFeatures,
        features: _.filter(this.state.drogiFeatures.features, v => v.properties.id !== road.id)
      }
    }, this.refreshRoads);
  }

  // Zmienia wartosc w inpucie odnosnie drog
  roadChange = (val) => {
    let road = null;
    let isAdding = null;
    if (this.state.selectedRoads.length > val.length) {
      road = _.differenceWith(this.state.selectedRoads, val, _.isEqual)[0];
      isAdding = false;
    }

    if (this.state.selectedRoads.length < val.length) {
      road = _.differenceWith(val, this.state.selectedRoads, _.isEqual)[0];
      isAdding = true;
    }

    // Przypisuje wartosc do state
    if (road && isAdding) {
      this.roadAdd(road, val);
    }

    if (road && !isAdding) {
      this.roadRemove(road);
    }
  }

  sposobChange = (e) => {
    if (e.target.value == 0) {
      this.setState({
        selectedSposob: 0, selectDrogi: false, selectDzialki: false, selectWybor: true, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: []
        }
      })
    } else if (e.target.value == 1) {
      this.setState({
        selectedSposob: 1, selectDrogi: false, selectDzialki: true, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: [],
        }
      }, () => {
        this.refreshRoads();
        this.refreshParcels();
      })
      this.props.setSelectDzialki(this.state.selectDzialki)
    } else if (e.target.value == 2) {
      this.setState({
        selectedSposob: 2, selectDrogi: true, selectDzialki: false, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: []
        }
      }, () => {
        this.refreshRoads();
        this.refreshParcels();
      });
      this.props.setSelectDrogi(this.state.selectDrogi)
    }
  }

  onMouseUp = (e) => {
    // if (this.state.isSelectionEnabled) {
    //   this.setState({ ctrState: e.originalEvent.ctrlKey }, this.endSelection);
    // }
    if (this.state.isRectangleDrawingEnabled) {
      this.setState({ ctrState: e.originalEvent.ctrlKey }, this.endSelection);
    }
  };
  onMouseMove = (e) => {
    if (this.state.isRectangleDrawingEnabled) {
      // if we have start point then we're drawing
      if (this.state.startPoint) {
        this.setState({ endPoint: e.latlng }, () => {
          if (this.state.ctrState !== e.originalEvent.ctrlKey) {
            this.endSelection();
          }
        });
      }
    }
  };

  removeParcelFromMap = parcel => {
    this.setState({
      parcelFeatures: _.filter(this.state.parcelFeatures, v => {
        if (parcel.label === v.properties.nr_dzialki && parcel.obreb === v.properties.obreb) {
          return;
        }
        return v;
      }),
    }, this.refreshParcels);
  }

  addParcelToMap = parcel => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel?nr_dzialki=${parcel.label}&precint=${parcel.obreb}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json();
      }
      throw r;
    })
    .then(response => {
      this.setState({ parcelFeatures: this.state.parcelFeatures.concat(response) }, this.refreshParcels);
    });

  getRoadsByBbox = (startP, endP) =>
    fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/roads_in_box?latStart=${startP.lat}&lngStart=${startP.lng}&latEnd=${endP.lat}&lngEnd=${endP.lng}`,
      { method: 'GET' })
      .then(r => {
        if (r.status === 200) {
          return r.json()
        }
        throw "Nie zaznaczono działek";
      })

  endSelection = () => {
    // cleanup selection
    // ctrState: false,
    // const d = new Date();
    const startP = this.state.startPoint;
    const endP = this.state.endPoint;
    this.setState({ startPoint: null, endPoint: null });


    this.setState({ startPoint: null, endPoint: null }, () => {
      const d = new Date();
      const selectTime = d.getTime() - this.state.startSelectTime;
      if (this.state.selectDzialki && selectTime > 200 && endP) {
        this.props.addGeomByRectangleIntersection(this.props.idx, startP, endP);

      }
    });
    //     // ZimoweUtrzymanieDrog
    //     let url = `${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel_in_box?latStart=${startP.lat}&lngStart=${startP.lng}&latEnd=${endP.lat}&lngEnd=${endP.lng}`;
    //     if (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo') {
    //       url += '&check_intersection=' + 'zimowe_utrzymanie_drog';
    //     }
    //     fetch(url,
    //       { method: 'GET' })
    //       .then(r => {
    //         if (r.status === 200) {
    //           return r.json()
    //         }
    //         throw r;
    //       })
    //       .then(response => {
    //         let parcels = [];
    //         let not_valid_parcels = [];
    //         let filtered_parcels = [];
    //         for (let i = 0; i <= response.features.length - 1; i++) {

    //           const parcel = {
    //             value: response.features[i].properties.nr_dzialki,
    //             label: response.features[i].properties.nr_dzialki,
    //             obreb: response.features[i].properties.obreb,
    //           }
    //           if (Object.keys(response.features[i].properties).indexOf('is_intersected') > -1 && (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo')) {
    //             if (response.features[i].properties.is_intersected) {
    //               parcels.push(parcel);
    //               filtered_parcels.push(response.features[i]);
    //             } else {
    //               not_valid_parcels.push(parcel);
    //             }
    //           } else {
    //             parcels.push(parcel);
    //           }

    //         }
    //         if (not_valid_parcels.length > 0 && (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo')) {

    //           const errorTitle = 'Błednie wskazano działki';
    //           const errorText = "Działki: " + not_valid_parcels.reduce((prev, cur) => cur.value + ';' + prev, '') + " nie znajdują się pobliżu dróg. Działki te nie zostaną dodane do mapy.";
    //           const showError = true;
    //           this.setState({
    //             selectedParcels: parcels,
    //             parcelFeatures: filtered_parcels,
    //             errorTitle: errorTitle,
    //             errorText: errorText,
    //             showError: showError,
    //           }, () => this.refreshParcels());
    //         } else {
    //           this.setState({ selectedParcels: parcels, parcelFeatures: response.features }, () => this.refreshParcels());
    //         }
    //       });
    //   }
    //   if (this.state.selectDrogi && selectTime > 200 && endP) {
    //     this.getRoadsByBbox(startP, endP)
    //       .then(r => {
    //         let roads = [];
    //         for (let i = 0; i <= r.features.length - 1; i++) {
    //           roads.push({ value: r.features[i].properties.nr_drogi, label: r.features[i].properties.nr_drogi, id: r.features[i].properties.id })
    //         }
    //         this.setState({
    //           selectedRoads: roads, drogiFeatures: {
    //             ...r
    //           }
    //         }, this.refreshRoads)
    //       })
    //   }
    // });
  }
  refreshParcels = () => {
    this.props.setParcels(this.state.selectedParcels);

    // Refresh roads onle when they are enabled
    if (this.props.dokumentType.enableRoads)
      this.props.setRoads(this.state.selectedRoads);

    if (this.state.selectedParcels.length > 0) {
      if (this.dzialki.leafletElement) {
        this.dzialki.leafletElement.clearLayers();
        const data = {
          type: 'FeatureCollection',
          features: this.state.parcelFeatures,
        };
        const bounds = this.dzialki.leafletElement.addData(data).getBounds();
        // fit map only if it is not a mouse event
        if (!this.state.isMouseEvent) this.mapka.leafletElement.fitBounds(bounds);
      }
    } else {
      if (this.dzialki && this.dzialki.leafletElement) {
        this.dzialki.leafletElement.clearLayers();
      }
      this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds), 11)
    }
  };

  refreshRoads = () => {
    if (this.state.drogiFeatures.features.length > 0) {
      if (this.drogi.leafletElement) {
        this.drogi.leafletElement.clearLayers();
        this.props.setRoads(this.state.selectedRoads);
        const bounds = this.drogi.leafletElement.addData(this.state.drogiFeatures).getBounds();
        if (!this.state.isMouseEvent) this.mapka.leafletElement.fitBounds(bounds);
      }
    } else {
      this.props.setRoads([]);
      if (this.drogi.leafletElement) {
        this.drogi.leafletElement.clearLayers();
      }
      this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds), 11)
    }
  }
  /* eslint-disable no-underscore-dangle */
  onPan = (e) => {
    const button = e.target.id;
    if (this.mapka) {
      if (button === 'move_map') {
        this.unBindButtons();
        this.setState({
          isSelectionEnabled: false,
          isTreeSelectionEnabled: false,
          isRectangleDrawingEnabled: false,
          isPolygonDrawingEnabled: false }, () => this.changeSelection());
      } else if (button === 'select_parcel') {
        this.bindButtons();
        this.setState({
          isSelectionEnabled: true,
          isTreeSelectionEnabled: false,
          isRectangleDrawingEnabled: false,
          isPolygonDrawingEnabled: false }, () => this.changeSelection());
      } else if (button === 'drawByRectangle') {
        this.unBindButtons();
        this.setState({
          isSelectionEnabled: false,
          isTreeSelectionEnabled: false,
          isRectangleDrawingEnabled: true,
          isPolygonDrawingEnabled: false }, () => this.changeSelection());
      } else if (button === 'drawByPolygon') {
        this.bindButtons();
        this.setState({
          isSelectionEnabled: false,
          isTreeSelectionEnabled: false,
          isRectangleDrawingEnabled: false,
          isPolygonDrawingEnabled: true }, () => this.changeSelection());
      }
      if (button !== 'drawByPolygon') {
        this.cancelDrawing();
      }
    }
  }

  changeSelection = () => {
    if (this.state.isSelectionEnabled || this.state.isRectangleDrawingEnabled || this.state.isPolygonDrawingEnabled) {
      this.mapka.leafletElement._container.style.cursor = 'crosshair';
      this.mapka.leafletElement.dragging.disable();
    } else {
      this.mapka.leafletElement._container.style.cursor = '';
      this.mapka.leafletElement.dragging.enable();
    }
  }

  whenClicked = (e) => {
    if (this.props.selectedMaterialName) {
      if (this.state.isSelectionEnabled) {
        this.props.addGeomByPointIntersection(this.props.idx, e.latlng);
      }
      if (this.state.isPolygonDrawingEnabled) {
        const poly = this.state.polyDrawingFeature;
        const drawingPoints = this.state.drawingPoints + 1;
        if (drawingPoints === 1) {
          poly.geometry.type = 'Point';
          poly.geometry.coordinates = [e.latlng.lng, e.latlng.lat];
        } else if (drawingPoints === 2) {
          poly.geometry.type = 'LineString';
          poly.geometry.coordinates = [poly.geometry.coordinates, [e.latlng.lng, e.latlng.lat]];
        } else if (drawingPoints === 3) {
          poly.geometry.type = 'Polygon';
          const coords = poly.geometry.coordinates;
          coords.push([e.latlng.lng, e.latlng.lat]);
          poly.geometry.coordinates = [coords];
        } else {
          poly.geometry.type = 'Polygon';
          poly.geometry.coordinates[0].push([e.latlng.lng, e.latlng.lat]);
        }

        this.setState({ drawingPoints, polyDrawingFeature: poly }, () => this.updatePolyDrawingMarkers());
      }
    }
  }

  mapRender = () => {
    const geojsonData = this.props.materialGeoms;
    const key = Math.random();

    const deviceWidth = window.innerWidth;
    let mapStyle;
    if (deviceWidth >= 560) {
      mapStyle = {
        width: '100%',
        height: '600px',
        border: 'solid 2px black',
        zIndex: '0',
      };
    } else {
      mapStyle = {
        width: '100%',
        height: '450px',
        border: 'solid 2px black',
        zIndex: '0',
      };
    }

    const layerDict = {
      'mapa glebowo-rolnicza w skali 1:5 000': 'GLEB_92_5',
      'mapa hydrograficzna, PL-1992': 'HYDRO_92_50',
      'mapa hydrograficzna, 1965': 'HYDRO_92_50',
      'Niestandardowe opracowania topograficzne w skali 1:10 000, 1965': 'NSOK_65_10',
      'Niestandardowe opracowania topograficzne w skali 1:25 000, 1965': 'NSOK_65_25',
      'Niestandardowe opracowania topograficzne w skali 1:50 000, 1965': 'NSOK_65_50',
      'Niestandardowe opracowania topograficzne w skali 1:100 000, GUGiK80': 'NSOK_80_100',
      'Niestandardowe opracowania topograficzne w skali 1:10 000, PL-1992': 'NSOK_92_10',
      'Niestandardowe opracowania topograficzne w skali 1:50 000, PL-1992': 'NSOK_92_50',
      'mapa sozologiczna, PL-1992': 'SOZO_92_50',
      'mapa sozologiczna, PL-1942': 'SOZO_92_50',
      'mapa topograficzna w skali 1:10 000, PL-UTM': 'SOK_92_10',
    };

    const mapa = (
      <Map
        ref={m => {
          this.mapka = m;
          window.__MAP__ = m;
        }}
        center={this.state.center}
        style={mapStyle}
        zoom={zoom}
        minZoom={zoom}
        onLoad={() => this.onMapLoad()}
        // onClick={(e) => this.onMapClick(e)}
        // onKeyDown={(e) => this.onKeyDown(e)}
        // onKeypress={(e) => this.onkeypress(e)}
        onMousedown={(e) => this.onMouseDown(e)}
        onMouseup={(e) => this.onMouseUp(e)}
        onMousemove={(e) => this.onMouseMove(e)}
        animate
        id="divToPrint_PDF"
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {this.props.selectedMaterialName && Object.keys(layerDict).indexOf(this.props.selectedMaterialName) > -1 ?
          <WMSTileLayer
            url={`${process.env.GEOSERVER}/myworkspace/wms?`}
            format={'image/png'}
            transparent
            layers={layerDict[this.props.selectedMaterialName]}
          />
        : null }

        <WMSTileLayer
          url={`https://e-spdp.pl/geoserver/${this.state.prefix}/wms?`}
          format={'image/png'}
          transparent
          layers={'granica_gminy'}
        />

        {/* geometrie danego materiału */}
        { geojsonData.features &&
          <GeoJSON
            key={`geoms_${key}`}
            cursor={'crosshair'}
            data={geojsonData}
            style={geomStyle}
          />
        }

        {/* wybrane godła */}
        {this.props.selectedGeoms.length > 0 ? (
          <GeoJSON
            key={`selectedGeoms_${key}`}
            cursor={'crosshair'}
            data={{
              type: 'FeatureCollection',
              features: this.props.selectedGeoms,
            }}
            style={selectedGeomStyle}
          />
        ) : null}

        {/* narysowany obiekt */}
        {this.state.drawingPoints > 1 ? (
          <GeoJSON
            key={`polyDrawingFeature_${key}`}
            cursor={'crosshair'}
            data={this.state.polyDrawingFeature}
            style={drawingGeomStyle}
          />
        ) : null}

        {this.state.polyDrawingMarkers.map((val, i) => {
          return (
            <Marker
              key={`polyDrawingMarker_${key}_${i}`}
              position={val}
              icon={L.divIcon({
                className: 'my-custom-icon',
                iconAnchor: [5, 5],
                iconSize: [10, 10],
              })}
            />
          );
        },
        )}

        {/* zaznaczony obiekt na liście wybranych  */}
        {this.props.highlightedGeoms.length > 0 ? (
          <GeoJSON
            key={`highlightedGeoms_${key}`}
            cursor={'crosshair'}
            data={{
              type: 'FeatureCollection',
              features: this.props.highlightedGeoms,
            }}
            style={highlightedGeomStyle}
          />
        ) : null}


        {this.state.parcelFeatures.length > 0 ? (
          <GeoJSON
            ref={m => { this.dzialki = m; }}
            cursor={'crosshair'}
            data={{
              type: 'FeatureCollection',
              features: this.state.parcelFeatures,
            }}
          />
        ) : null}

        <GeoJSON
          ref={obj => { this.drogi = obj; }}
          cursor={'crosshair'}
          data={this.state.drogiFeatures}
        />

        {/*selection rectangle*/}
        {(this.state.startPoint && this.state.endPoint) ? (
          <Rectangle
            bounds={[[this.state.startPoint.lat, this.state.startPoint.lng], [this.state.endPoint.lat, this.state.endPoint.lng]]}
          />
        ) : null}
        {this.state.listTrees.map((val, i) => {
          return (
            <Marker
              key={i}
              position={val.latlng}
              onClick={() => this.removeTree(i)}
              icon={L.divIcon({
                className: 'my-custom-icon',
                html: val.number,
                iconAnchor: [0, 0],
                iconSize: [20, 20],
              })}
            />
          );
        })}
      </Map>
    );
    this.mapa = mapa;
    // if (this.mapka) {
    //   this.mapka.leafletElement.setMinZoom(11);
    // }

    this.bindButtons();
    const buttonStyle = { top: '208px', zIndex: '999' };
    if (this.state.isPolygonDrawingEnabled) {
      buttonStyle.top = '304px';
    }
    return (
      <div className="row" style={{ padding: '10px' }}>
        <button
          onClick={(e) => this.onPan(e)}
          id="move_map"
          className={this.state.isSelectionEnabled || this.state.isRectangleDrawingEnabled || this.state.isPolygonDrawingEnabled ?
            'pan_btn leaflet-bar mytlip' :
            'pan_btn leaflet-bar mytlip active'}
          type="submit"
          style={buttonStyle}
        >
          <span className="mytliptxt">Przesuń mapę</span>
        </button>
        <button
          onClick={(e) => this.onPan(e)}
          id="select_parcel"
          className={!this.state.isSelectionEnabled ?
            'select_btn leaflet-bar mytlip' :
            'select_btn leaflet-bar mytlip active'}
          type="submit"
          style={buttonStyle}
        >
          {this.state.selectedSposob === 2 ?
            <span className="mytliptxt">Wskaż drogi na mapie</span> :
            <span className="mytliptxt">Wskaż na mapie</span>}
        </button>
        <button
          onClick={(e) => this.onPan(e)}
          id="drawByRectangle"
          className={!this.state.isRectangleDrawingEnabled ?
            'rectangle_btn leaflet-bar mytlip' :
            'rectangle_btn leaflet-bar mytlip active'}
          type="submit"
          style={buttonStyle}
        >
          <span className="mytliptxt">Zaznacz prostokątem</span>
        </button>
        <button
          onClick={(e) => this.onPan(e)}
          id="drawByPolygon"
          className={!this.state.isPolygonDrawingEnabled ?
            'polygon_btn leaflet-bar mytlip' :
            'polygon_btn leaflet-bar mytlip active'}
          type="submit"
          style={buttonStyle}
        >
          <span className="mytliptxt">Wrysuj na mapie</span>
        </button>
        {this.state.isPolygonDrawingEnabled ?
          <button
            onClick={() => this.removeLastPoint()}
            id="removeLastPoint"
            className={'remove_btn leaflet-bar mytlip'}
            type="submit"
            style={buttonStyle}
          >
            <span className="mytliptxt">Usuń ostatnio dodany punkt</span>
          </button>
        : null}
        {this.state.isPolygonDrawingEnabled ?
          <button
            onClick={() => this.cancelDrawing()}
            id="cancelDrawing"
            className={'cancel_btn leaflet-bar mytlip'}
            type="submit"
            style={buttonStyle}
          >
            <span className="mytliptxt">Anuluj rysowanie</span>
          </button>
        : null}
        {this.state.isPolygonDrawingEnabled ?
          <button
            onClick={() => this.finishPolyDrawing()}
            id="finishPolyDrawing"
            className={'finish_btn leaflet-bar mytlip'}
            type="submit"
            style={buttonStyle}
          >
            <span className="mytliptxt">Zatwierdź rysowanie</span>
          </button>
        : null}
        {mapa}
      </div>
    );
  }
  removeAllTrees = () => {
    this.setState({
      listTrees: [],
    });
  }

  removeTree = (i) => {
    const list = [...this.state.listTrees];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      listTrees: list,
    });
  }
  onChangeAddress = val => {
    this.getParcelInPoint({ lat: val.lat, lng: val.lon })
      .then(resp => {
        const parcel = {
          value: resp.properties.nr_dzialki,
          label: resp.properties.nr_dzialki,
          obreb: resp.properties.obreb,
        };
        this.setState({
          selectedParcels: this.state.selectedParcels.concat(parcel),
          selectedAddress: { value: resp.properties.nr_dzialki, label: val.display_name, obreb: resp.properties.obreb },
          parcelFeatures: this.state.parcelFeatures.concat(resp)
        }, this.refreshParcels);
      })
      .catch(err => {
        // TODO: Create message box with information that user choosen address point outside district
      });
  }
  inputAdressChange = e => {
    const query = `http://nominatim.openstreetmap.org/search/pl?format=json&q=${e}&accept-language=pl-PL&countrycodes=pl`;
    fetch(query, { method: 'GET' })
      .then(r => {
        return r.json();
      })
      .then(resp => {
        this.setState({
          adresses: resp.map(address => {
            return { ...address, label: <span><img src={address.icon} />{address.display_name}</span>, value: address.display_name };
          })
        })
      }
      );
  }

  matcher = e => {
    let matches = [];
    let matchesLength = [];
    let substrRegex = new RegExp("^" + e, 'i');
    let mach = {}
    this.state.parc.forEach(parc => {
      let s = parc.value.split('-');
      if (s[1] && substrRegex.test(s[1])) {
        let dictKey = `lenght${Math.abs(e.length - s[1].length)}`;
        if (Object.keys(mach).indexOf(dictKey) >= 0) {
          mach[dictKey].push(parc);
        } else {
          mach[dictKey] = [parc];
        }
        if (s[1].length === e.length) {
          matchesLength.push(parc)
        } else {
          matches.push(parc)
        }

      }
    });
    let machKeys = Object.keys(mach).sort();
    let odpSum = [];
    for (let key of machKeys) {
      odpSum = [...odpSum, ...mach[key]];
    }
    this.setState({ parcels: odpSum });
  }

  checkMPZP = (list) => {
    // sprawdza przynależność do mpzp
    let mpzpBool = true;
    let alertBool = false;
    let nonMpzp = [];
    list.map((i, y) => {
      if (i.properties.mpzpCount > 0 && i.properties.mpzpCount !== null) {
        mpzpBool = true;
        alertBool = false;
      } else {
        mpzpBool = false;
        alertBool = true;
        nonMpzp.push(i.properties.nr_dzialki);
      }
    });
    this.setState({ areParcelsInMPZP: mpzpBool, nonMpzpAlert: alertBool, nonMpzpList: nonMpzp });
  }

  // componentDidUpdate(prevProps, prevState) {
  //   const parcelFeature = this.state.parcelFeatures;
  //   const servicesToCheckMPZP = [
  //     'WypisIWyrysZMpzp',
  //     'WypisZMpzp',
  //     'WyrysZMpzp',
  //     'WniosekUproszczonyWypis',
  //     'ZaswiadczenieMPZP',
  //   ];
  //   if (servicesToCheckMPZP.includes(this.props.dokumentType.shortName) && prevState.parcelFeatures !== this.state.parcelFeatures && parcelFeature !== []) {
  //     // określa dla jakich dokumentów ma wyświetlać komunikat o braku przynależności do mpzp
  //     this.checkMPZP(parcelFeature);
  //   }
  // }

  render() {
    const validMpzp = this.state.areParcelsInMPZP;
    if (this.props.mpzpValidator) this.props.mpzpValidator(validMpzp);
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';
    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    let obreby = this.props.obreby;
    if (obreby && typeof (obreby) === 'string') {
      obreby = JSON.parse(this.props.obreby);
    }

    return (
      <div>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHideErrorModal}
        />
        {!this.state.areParcelsInMPZP ? <MessageModal message={2} messageText={this.state.nonMpzpList} openModal={this.state.nonMpzpAlert} closeModal={() => this.setState({ nonMpzpAlert: false })} /> : null}
        {this.state.showMessage ? <MessageModal message={1} openModal={this.state.showMessage} closeModal={() => this.setState({ showMessage: false })} /> : null}
        {this.props.dokumentType.enableAddress &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="dzialki" style={labelStyle} >Adres</label>
            </div>
            <div className={inputCol}>
              <Select
                noResultsText={'brak wyników'}
                placeholder="wpthis.state.isMountedisz adres..."
                name="form-field-name"
                value={this.state.selectedAddress}
                options={this.state.adresses}
                clearable
                rows={5}
                onInputChange={this.inputAdressChange}
                onChange={this.onChangeAddress}
              />
            </div>
            <div className={rightCol}>
              <button
                onClick={() => {
                  this.setState({ selectedAddress: '', selectedParcels: [], parcelFeatures: [] }, () => {
                    this.props.setParcels(this.state.selectedParcels);
                    this.props.setRoads(this.state.selectedRoads);

                    this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds),
                      11);
                  }
                  )
                }}
                className="btn btn-default" type="submit"><strong>Wyczyść</strong>
              </button>
            </div>
          </div>
        }

        {this.props.dokumentType.enableRoads && this.state.selectWybor &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="szukaj" style={labelStyle} >Wyszukaj na podstawie</label>
            </div>

            <div className={inputCol}>
              <select
                name="find"
                className="form-control"
                value={this.state.selectedSposob}
                onChange={(e) => this.sposobChange(e)}
              >
                <option value="0">Wybierz sposób...</option>
                <option value="1">Działki</option>
                <option value="2">Drogi</option>

              </select>
            </div>
            <div className={rightCol} />
          </div>
        }

        {this.props.dokumentType.enablePrecints && this.state.selectDzialki && this.state.selectedSposob !== 2 &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="dzialki" style={labelStyle} >Obręby</label>
            </div>
            <div className={inputCol}>
              <select
                name="obreby"
                className="form-control"
                value={this.state.selectedPrecint}
                onChange={(e) => this.onChangePrecint(e)}
              >
                {obreby.map((v, i) => {
                  return <option key={i} value={v.obreb}>{v.nazwa_obrebu}</option>
                })}
              </select>
            </div>
            <div className={rightCol} />
          </div>
        }
        {this.props.dokumentType.enableParcels && this.state.selectDzialki && this.state.selectedSposob !== 2 &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="dzialki" style={labelStyle} >Działki</label>
            </div>
            <div className={inputCol}>
              <Select
                noResultsText={'brak wyników'}
                placeholder="wpisz numer działki..."
                multi
                name="form-field-name"
                value={this.state.selectedParcels}
                options={this.state.parcels}
                clearable={false}

                onInputChange={(e) => this.matcher(e)}
                onChange={this.logChange}
              />

            </div>
            <div className={rightCol}>
              <button onClick={() => this.clearSelection()} className="btn btn-default" type="submit"><strong>Odznacz wszystko</strong></button>
            </div>
          </div>
        }
        {this.props.dokumentType.enableRoads && this.state.selectDrogi && this.state.selectedSposob === 2 &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="drogi" style={labelStyle} >Drogi</label>
            </div>
            <div className={inputCol}>
              <Select
                noResultsText={'brak wyników'}
                placeholder="wpisz numer drogi..."
                multi
                name="form-field-name"
                value={this.state.selectedRoads}
                options={this.state.roads}
                clearable={false}
                onChange={this.roadChange}
              />

            </div>
            <div className={rightCol}>
              <button onClick={() => this.clearSelection()} className="btn btn-default" type="submit"><strong>Odznacz wszystko</strong></button>
            </div>
          </div>
        }
        {
          this.state.isMounted ? this.mapRender() : <div style={waitingContainer}>
            <img role="presentation" src={waiting} />
          </div>
        }
        {this.state.parcelError ?
          <div><h5><b>{this.state.parcelError}</b></h5></div>
          : null
        }
      </div>
    );
  }
}

CustomizedMap.propTypes = {
  obreby: PropTypes.array,
  district: PropTypes.object,
  settings: PropTypes.object,
  setParcels: PropTypes.func,
  setRoads: PropTypes.func,
  setSelectDrogi: PropTypes.func,
  setSelectDzialki: PropTypes.func,
};

// eservices?customerId=E819A999-4CAF-45D1-AF89-A38628EBFF6F&district=1815033&serviceType=WypisIWyrysZeStudium
const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts
});

export default connect(mapState)(CustomizedMap);



// WEBPACK FOOTER //
// src/routes/eservices/CustomizedMap.js